<div
    class="form-group form-group-col form-group-3-col form-control-f-w no-padding flexbox flex-wrap d-flex mb-0"
    [ngClass]="{ 'enable-valid-sugar': !fromUkgc }">
    <ng-template #monthForm>
        <lh-form-field layout="col" [labelText]="monthPlaceholder" [ngClass]="showMonthFirst ? 'col-4 pl-0' : 'col-4 px-0'">
            <input
                #month="ngModel"
                maxlength="2"
                minlength="1"
                name="month"
                pattern="[0-9]*"
                ptNumberOnly
                type="tel"
                [attr.autocomplete]="autocomplete && 'bday-month'"
                [disabled]="isDisabled"
                [ngModel]="model.month"
                [required]="required"
                (blur)="onMonthChange($event)"
                (focus)="onFieldFocus('month')"
                (ngModelChange)="onModelChange($event, 'month')" />
            <span class="theme-error-i position-absolute hide"></span>
            <!-- worldcup changes -->
            @if (isEntertainmentRegistration) {
                <i class="worldcup__input-icn theme-soccer"></i>
            }
            <!-- end of worldcup changes -->
        </lh-form-field>
    </ng-template>
    <ng-template #dayForm>
        <lh-form-field layout="col" [labelText]="dayPlaceholder" [ngClass]="!showMonthFirst ? 'col-4 pl-0' : 'col-4 px-0'">
            <input
                #day="ngModel"
                maxlength="2"
                minlength="1"
                name="day"
                pattern="[0-9]*"
                ptNumberOnly
                type="tel"
                [attr.autocomplete]="autocomplete && 'bday-day'"
                [disabled]="isDisabled"
                [ngModel]="model.day"
                [required]="required"
                (blur)="onDayChange($event)"
                (focus)="onFieldFocus('day')"
                (ngModelChange)="onModelChange($event, 'day')" />
            <span class="theme-error-i position-absolute hide"></span>
            <!-- worldcup changes -->
            @if (isEntertainmentRegistration) {
                <i class="worldcup__input-icn theme-soccer"></i>
            }
            <!-- end of worldcup changes -->
        </lh-form-field>
    </ng-template>
    @if (showMonthFirst) {
        <ng-container *ngTemplateOutlet="monthForm"></ng-container>
    } @else {
        <ng-container *ngTemplateOutlet="dayForm"></ng-container>
    }
    @if (showMonthFirst) {
        <ng-container *ngTemplateOutlet="dayForm"></ng-container>
    } @else {
        <ng-container *ngTemplateOutlet="monthForm"></ng-container>
    }
    <lh-form-field class="col-4 pr-0" layout="col" [labelText]="yearPlaceholder">
        <input
            #year="ngModel"
            maxlength="4"
            minlength="4"
            name="year"
            pattern="[0-9]*"
            ptNumberOnly
            type="tel"
            [attr.autocomplete]="autocomplete && 'bday-year'"
            [disabled]="isDisabled"
            [ngModel]="model.year"
            [required]="required"
            (blur)="onYearChange($event)"
            (focus)="onFieldFocus('year')"
            (ngModelChange)="onModelChange($event, 'year')" />
        <span class="theme-error-i position-absolute hide"></span>
        <!-- worldcup changes -->
        @if (isEntertainmentRegistration) {
            <i class="worldcup__input-icn theme-soccer"></i>
        }
        <!-- end of worldcup changes -->
    </lh-form-field>
</div>
